import { render, staticRenderFns } from "./DinamicImgField.vue?vue&type=template&id=160a834c&scoped=true&"
import script from "./DinamicImgField.vue?vue&type=script&lang=js&"
export * from "./DinamicImgField.vue?vue&type=script&lang=js&"
import style0 from "./DinamicImgField.vue?vue&type=style&index=0&id=160a834c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a834c",
  null
  
)

export default component.exports